import gql from 'graphql-tag';

export default gql`
mutation enableBankTransferForBillingAddress (
    $address_id: ID!
    $enable: Boolean!
) {
    enableBankTransferForBillingAddress (
        address_id: $address_id,
        enable: $enable,
    ) {
        id
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/enableBankTransferForBillingAddress.ts